const binding = { modules: {}, dataActions: {} };

    (binding.modules['defa-business-sign-up'] = {
        c: () => require('partner/modules/defa-business-sign-up/defa-business-sign-up.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'defa-business-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/defa-business-sign-up'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|defa-business-sign-up|defa-business-sign-up'] = {
                c: () => require('partner/modules/defa-business-sign-up/defa-business-sign-up.view.tsx'),
                cn: '__local__-__local__-defa-business-sign-up'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };